import { LinkDownloadType } from "../../../tracking/LinkDownloadType.js";
import type { FinalFormTrackingObject } from "../../../widgetDataTs.js";
import { isString, type Nil } from "@mcwd/typescript-type-guards";
import { ImageElement, type CtaElementData } from "./CtaElementData.js";

export type CtaData = {
    ctaText: string; 
    ctaType:  LinkDownloadType | Nil;
    ctaClass: string;
}

export class FormCtaDataManager {

  private CtaType: LinkDownloadType | Nil;
  private CtaText: string | Nil;
  private CtaElementData: CtaElementData;
  private JQuereyElement: JQuery<HTMLElement> | Nil;

  constructor(TrackingData: FinalFormTrackingObject, CtaElement: CtaElementData) {
    const { ctaText, ctaType, ctaElement } = TrackingData;
    this.JQuereyElement = ctaElement;
    
    this.CtaType = ctaType ?? CtaElement?.getCtaType();
    this.CtaText = ctaText;
    this.CtaElementData = CtaElement;
  }
  
  get Element() {
    return this.JQuereyElement;
  }
  
  get Type(){
    return this.CtaType;
  }
  get AnalyticData(): CtaData{
    return {
      ctaType: this.getCtaType(),
      ctaText: this.getCtaText(),
      ctaClass: this.getCtaClass()
    };
  }
  /**
   * Gets the CTA Text from the tracking data or html element (text/attribute/src(images)) 
   * @returns The CTA Text or the last segment of image url
   */
  getCtaText() {
    if (this.CtaText && !(this.CtaElementData instanceof ImageElement)) {
      return this.#validateAndFormatMyString(this.CtaText);
    }
    return this.#validateAndFormatMyString(this.CtaElementData.getCtaText());
  }
  /**
   * Gets the CTA Type of the CTA that launched the form
   * @returns The CTA Type
   */
  getCtaType(){
    return this.CtaElementData.getCtaType();
  }
  /**
   * Gets the class that is applied to the CTA that launched the form
   * @returns The class applied to the CTA
   */
  getCtaClass() {
    return this.#validateAndFormatMyString(this.CtaElementData.getCtaClassList());
  }
  /**
   * Gets the styles applied the CTA element
   * @returns The basic styles applied to the cta element
   */
  getCtaStyles() {
    return this.CtaElementData.getBasicStyles();
  }

  #validateAndFormatMyString(input: string | Nil) {
    if (!isString(input)) return "";
    const MAX_LENGTH = 100;
    if (input.length <= MAX_LENGTH) {
      return input;
    }
    const truncated = input.slice(0, MAX_LENGTH - 4);
    return `CUT:${truncated}`;
  }
}

